import cacheKeys from '@/data/api/cacheKeys';
import { getKamList } from '@/data/api/request/staffRequests';
import { ONE_SECOND_MS } from '@/utils/time';
import { useQuery } from '@tanstack/react-query';

export function useGetKamList() {
  const { data, error, isLoading } = useQuery({
    queryKey: [cacheKeys.staff.kamList],
    queryFn: () => getKamList(),
    staleTime: 20 * ONE_SECOND_MS,
  });

  return {
    data,
    error,
    isLoading,
  };
}
